export enum MessageStatus {
  Queued = 'Queued',
  Delivered = 'Delivered',
  ConfirmedDelivered = 'Confirmed Delivered',
  Error = 'Error',
  ConfirmedError = 'Confirmed Error',
  Unsent = 'Unsent',
}
